/**
 * 日付を指定されたフォーマットで文字列に変換する
 * @param {Date|string} date - フォーマットする日付
 * @param {string} format - フォーマット文字列 (デフォルト: 'YYYY/MM/DD')
 * @returns {string} フォーマットされた日付文字列
 */
export const formatDate = (date, format = 'YYYY/MM/DD') => {
  if (!date) return '';

  const d = new Date(date);

  // 無効な日付の場合は空文字を返す
  if (isNaN(d.getTime())) return '';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};

/**
 * 日付を YYYY/MM/DD 形式でフォーマットする
 * @param {Date|string} date - フォーマットする日付
 * @returns {string} YYYY/MM/DD 形式の日付文字列
 */
export const formatDateShort = (date) => {
  return formatDate(date, 'YYYY/MM/DD');
};

/**
 * 日付を YYYY/MM/DD HH:mm 形式でフォーマットする
 * @param {Date|string} date - フォーマットする日付
 * @returns {string} YYYY/MM/DD HH:mm 形式の日付文字列
 */
export const formatDateTime = (date) => {
  return formatDate(date, 'YYYY/MM/DD HH:mm');
};

/**
 * 日付を YYYY/MM/DD HH:mm:ss 形式でフォーマットする
 * @param {Date|string} date - フォーマットする日付
 * @returns {string} YYYY/MM/DD HH:mm:ss 形式の日付文字列
 */
export const formatDateTimeFull = (date) => {
  return formatDate(date, 'YYYY/MM/DD HH:mm:ss');
};
